export const saveToSessionStorage = (key, value) => {
  if (typeof window === "undefined") return;
  try {
    const serializedValue = JSON.stringify(value);
    window.sessionStorage.setItem(key, serializedValue);
  } catch (error) {
    console.warn(`Error saving to sessionStorage with key “${key}”:`, error);
  }
};

export const getFromSessionStorage = key => {
  if (typeof window === "undefined") return null;
  try {
    const serializedValue = window.sessionStorage.getItem(key);
    return serializedValue ? JSON.parse(serializedValue) : null;
  } catch (error) {
    console.warn(`Error reading from sessionStorage with key “${key}”:`, error);
    return null;
  }
};

export const clearFromSessionStorage = key => {
  if (typeof window === "undefined") return;

  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    console.warn(
      `Error removing from sessionStorage with key “${key}”:`,
      error
    );
  }
};
